/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Wiz_RunInputs */

const cs_addr_wiz_run = /** @type {(inputs: Addr_Wiz_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najít návrhy`)
};

const en_addr_wiz_run = /** @type {(inputs: Addr_Wiz_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find suggestions`)
};

/**
* | output |
* | --- |
* | "Find suggestions" |
*
* @param {Addr_Wiz_RunInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_wiz_run = /** @type {((inputs?: Addr_Wiz_RunInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Wiz_RunInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_wiz_run(inputs)
	return cs_addr_wiz_run(inputs)
});